/**
 * Converts a JS object into FormData recursively.
 * @param {Object} obj - The data object to convert.
 * @param {FormData} [formData] - Optional existing FormData.
 * @param {string} [parentKey] - Used internally for recursion.
 * @returns {FormData}
 */
export function convertToFormData(
  obj,
  formData = new FormData(),
  parentKey = ""
) {
  if (obj == null) return formData;

  Object.entries(obj).forEach(([key, value]) => {
    const fullKey = parentKey ? `${parentKey}[${key}]` : key;

    if (value instanceof File || value instanceof Blob) {
      formData.append(fullKey, value);
    } else if (Array.isArray(value)) {
      value.forEach((item, index) => {
        const arrayKey = `${fullKey}[${index}]`;

        if (item instanceof File || item instanceof Blob) {
          formData.append(fullKey, item); // Keep as `images[]` format
        } else if (typeof item === "object" && item !== null) {
          convertToFormData(item, formData, arrayKey);
        } else {
          formData.append(fullKey, item);
        }
      });
    } else if (typeof value === "object" && value !== null) {
      convertToFormData(value, formData, fullKey);
    } else if (typeof value !== "undefined") {
      formData.append(fullKey, value);
    }
  });

  return formData;
}
